import { Col, Row, Space } from "antd";
import { SvgArrowRightIcon } from "components/svg";
import articles from "pages/artikel/articles";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const articleCarousel = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  arrows: false,
  centerPadding: "50px",
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const ArticleHome = () => {
  const { isMobileView } = useSelector(({ settings }) => settings);
  const { phrases, locale } = useSelector(({ polyglot }) => polyglot);

  if (phrases) {
    const {
      pages: { home },
      components: { buttons },
    } = phrases;
    return (
      <div className="mpx-home--article">
        <div className="mpx-container" style={{ textAlign: "center" }}>
          <h1 className="mpx-title" style={{ marginBottom: "3rem" }}>
            {home.latestArticles}
          </h1>
          {/* <p className='mpx-title-desc'>
            {home.latestArticlesText}
          </p> */}
          {!isMobileView && (
            <Row gutter={[18, 18]} style={{ marginBottom: "65px" }}>
              {articles[locale].map((x) => {
                const showarticles = articles[locale].length - 4;
                if (Number(x.id) > showarticles) {
                  return (
                    <Col lg={6} key={x.id}>
                      <div className="mpx-article--item">
                        <div className="mpx-article--content">
                          <div className="image">
                            <Link to={"/artikel/" + x.url}>
                              <img src={x.image} alt="MPX | Article" />
                            </Link>
                          </div>
                          <Space
                            size={10}
                            direction="vertical"
                            className="text"
                          >
                            <div className="date">{x.date}</div>
                            <Link to={"/artikel/" + x.url}>
                              <h2>{x.title}</h2>
                            </Link>
                            <div className="preview">{x.preview}</div>
                          </Space>
                        </div>
                        <div className="mpx-article--link">
                          <Link to={"/artikel/" + x.url}>
                            {buttons.readMore}
                            <SvgArrowRightIcon />
                          </Link>
                        </div>
                      </div>
                    </Col>
                  );
                }
                return false;
              })}
            </Row>
          )}
          {isMobileView && (
            <div style={{ marginBottom: "75px" }}>
              <div className="mpx-article">
                <Slider {...articleCarousel}>
                  {articles[locale].map((x) => {
                    const showarticles = articles[locale].length - 4;
                    if (Number(x.id) > showarticles) {
                      return (
                        <div>
                          <div className="mpx-article--item">
                            <div className="mpx-article--content">
                              <div className="image">
                                <Link to={"/artikel/" + x.url}>
                                  <img src={x.image} alt="MPX | Article" />
                                </Link>
                              </div>
                              <Space
                                size={10}
                                direction="vertical"
                                className="text"
                              >
                                <div className="date">{x.date}</div>
                                <Link to={"/artikel/" + x.url}>
                                  <h2>{x.title}</h2>
                                </Link>
                                <div className="preview">{x.preview}</div>
                              </Space>
                            </div>
                            <div className="mpx-article--link">
                              <Link to={"/artikel/" + x.url}>
                                {buttons.readMore}
                                <SvgArrowRightIcon />
                              </Link>
                            </div>
                          </div>
                        </div>
                      );
                    }
                    return false;
                  })}
                </Slider>
              </div>
            </div>
          )}
          {/* <Link to='#' className='mpx-btn'>
            <Space>
              {buttons.viewAllArticle}
              <SvgArrowRightIcon />
            </Space>
          </Link> */}
        </div>
      </div>
    );
  } else {
    return false;
  }
};

export default ArticleHome;
